















import Vue from 'vue';
import {Component, Emit} from "vue-property-decorator";
import AsiToolbar from "../common/AsiToolbar.vue";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import {Icon} from "@/helpers/icons";
import AsiBtn from "@/components/common/AsiBtn.vue";
import WeeklyOverview from "@/components/planning/WeeklyOverview.vue";
import {getWeekNumber} from "@/helpers/functions_asi";

@Component({
	components: {WeeklyOverview, AsiBtn, AsiContentContainer, AsiToolbar}
})
export default class OfficeWeeklyOverview extends Vue {

	private icons = Icon;
	private date: Date = new Date();
	private loading: boolean = false;

	private get title(): string {
		return this.$t('uiTerms.weeklyOverview')
			+ ' - '
			+ this.$t('uiTerms.weekNumber', {num: getWeekNumber(this.date)});
	}

	private today(): void {
		this.date = new Date();
	}

	private prevWeek(): void {
		const date = new Date(this.date);
		date.setDate(date.getDate() - 7);
		this.date = date;
	}

	private nextWeek(): void {
		const date = new Date(this.date);
		date.setDate(date.getDate() + 7);
		this.date = date;
	}

	private loadingChanged(loading: boolean): void {
		this.loading = loading;
	}

	@Emit('planningEntriesChanged')
	public planningEntriesChanged(event: Event): Event {
	    return event;
	}

}
